import { render, staticRenderFns } from "./inspection.vue?vue&type=template&id=f03b37bc&scoped=true"
import script from "./inspection.vue?vue&type=script&lang=js"
export * from "./inspection.vue?vue&type=script&lang=js"
import style0 from "./inspection.vue?vue&type=style&index=0&id=f03b37bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03b37bc",
  null
  
)

export default component.exports